import PSD2Warning from './PSD2Warning';
export { PSD2Warning };
export default PSD2Warning;
